import { basic, initSidebar, initTopbar } from './modules/layouts';
import { initLocaleDatetime } from './modules/plugins';

basic();
initSidebar();
initTopbar();
initLocaleDatetime();
